<!--
 * @Author: zhaoliang
 * @Date: 2024-05-08 14:46:03
 * @LastEditTime: 2024-07-02 17:44:42
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/LoungePrebook/Select/index.vue
 *
-->
<template>
  <div class="select-container" v-clickOutside="closeOptions">
    <div class="select-wrapper" @click="openOptions">
      <div class="select-content">{{ value }}</div>
      <div :class="['select-icon', optionsOpen ? 'open' : '']">
        <img src="~img/Shape.png" />
      </div>
    </div>
    <transition name="fade">
      <ul class="options-list" v-show="optionsOpen">
        <li
          class="options-item"
          v-for="(item, index) in options"
          :key="index"
          @click="clickOption(item)"
        >
          <span>{{ item }}</span>
          <img v-if="item === value" src="~img/icon-check-dark.svg" alt="" />
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>
  import { clickOutside } from '@/utils/directive.js';
  export default {
    name: 'Select',
    props: {
      options: {
        type: Array,
        default: [],
      },
      value: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        optionsOpen: false,
      };
    },
    directives: { clickOutside },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
      openOptions() {
        this.optionsOpen = !this.optionsOpen;
      },
      closeOptions() {
        this.optionsOpen = false;
      },
      clickOption(item) {
        this.$emit('onChange', item);
        this.closeOptions();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .select-container {
    position: relative;
    width: 100%;
    .select-wrapper {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #9eacb5;
      padding: 10px 10px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .select-content {
        padding-left: 10px;
        @include font($size: 24px, $weight: 600);
      }
      .select-icon {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s;

        img {
          width: 10px;
          height: 20px;
          transform: rotate(-90deg);
        }

        &.open {
          img {
            transform: rotate(90deg);
          }
        }
      }
    }

    .options-list {
      max-height: 400px;
      overflow-y: auto;
      width: 100%;
      position: absolute;
      right: 0;
      z-index: 10;
      box-sizing: border-box;
      padding: 10px 10px;
      background: #fff;
      border: 2px solid #bec7cc;
      border-radius: 8px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);

      .options-item {
        box-sizing: border-box;
        padding: 10px;
        font-size: 16px;
        font-weight: 400;
        line-height: 21px;
        color: #163049;
        white-space: nowrap;
        cursor: pointer;
        @include font($size: 18px, $weight: 600);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
          background: #eaeef0;
          border-radius: 5px;
        }

        img {
          width: 18px;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    .select-container {
      .select-wrapper {
        padding: 10px 10px;

        .select-content {
          @include font($size: 20px, $weight: 600);
        }
        .select-icon {
          width: 16px;
          height: 16px;

          img {
            width: 8px;
            height: 16px;
          }
        }
      }

      .options-list {
        max-height: 300px;
        padding: 5px 10px;

        .options-item {
          padding: 5px 10px;
          @include font($size: 16px, $weight: 400);

          img {
            width: 16px;
          }
        }
      }
    }
  }
</style>
